import sanityClient from '@sanity/client';
import { ENVIRONMENT } from './config';

export default sanityClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID, // find this at manage.sanity.io or in your sanity.json
    dataset: ENVIRONMENT, // this is from those question during 'sanity init'
    useCdn: true,
    apiVersion: 'v2021-10-21',
});
